import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useValidation } from 'gw-portals-validation-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './VehicleComponent.metadata.json5';
import {  useModal } from '@jutro/components';
import './VehicleComponent.messages';
import VehicleInfoLookupComponent from '../../../../../applications/quote-and-buy/src/customer/capabilities-react/gw-capability-vehicleinfo-react/VehicleInfoLookupComponent/VehicleInfoLookupComponent'


function VehicleComponent(props) {
    const {
        data: vehicleVM,
        readOnlyFields,
        labelPosition,
        showOptional,
        path,
        id,
        onValidate,
        onValueChange,
        accountHolder,
        vehicles,
        quoteId,
        addVehicleVM,
        createVehicle,
        removeVehicle,
        showErrors,
        garrageAddress,
        vinNumber,
        lease,
        isVehiclePrimarilyKeptAtAddress,
        callErrorHandler
    } = props;
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);
    const modal = useModal();

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, onValidate, isComponentValid, vehicleVM]);

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const newPath = changedPath.replace(/^vehicle\./, '');
            const fullPath = newPath === '' ? path : `${path}.${newPath}`;
            if (onValueChange) {
                onValueChange(value, fullPath);
            }
        },
        [onValueChange, path]
    );

    const overrideProps = {
        '@field': {
            showOptional,
            labelPosition
        },
        vehicleInfoLookupComponent: {
            // readOnly: _.includes(readOnlyFields, 'vinlookup'),
            accountHolder: accountHolder,
            garrageAddress: garrageAddress,
            vinNumber: vinNumber,
            lease: lease,
            isVehiclePrimarilyKeptAtAddress: isVehiclePrimarilyKeptAtAddress,
            vehicles: vehicles,
            quoteId: quoteId,
            addVehicleVM: addVehicleVM,
            createVehicle: createVehicle,
            removeVehicle: removeVehicle,
            showErrors: showErrors,
            callErrorHandler: callErrorHandler,
            modal: modal
        },
        vehicleLicencePlate: { readOnly: _.includes(readOnlyFields, 'vehicleLicencePlate') },
        driverLicenceState: { readOnly: _.includes(readOnlyFields, 'driverLicenceState') },
        vehicleCostNew: { readOnly: _.includes(readOnlyFields, 'vehicleCostNew') }
    };

    const resolvers = {
      resolveCallbackMap: {
        onValidate: setComponentValidation,
      },
      resolveComponentMap: {
        vehicleInfoLookupComponent: VehicleInfoLookupComponent,
      },
    };

    const data = {
        vehicle: vehicleVM
    };
    return (
        <ViewModelForm
            model={data}
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            onValidationChange={setComponentValidation}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

VehicleComponent.propTypes = {
    data: PropTypes.shape({}),
    accountHolder: PropTypes.shape({}),
    garrageAddress: PropTypes.shape({}),
    vinNumber: PropTypes.string,
    lease: PropTypes.bool,
    isVehiclePrimarilyKeptAtAddress: PropTypes.bool,
    vehicles: PropTypes.shape({}),
    labelPosition: PropTypes.string,
    path: PropTypes.string,
    onValueChange: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    readOnlyFields: PropTypes.arrayOf(PropTypes.string),
    showOptional: PropTypes.bool,
    id: PropTypes.string.isRequired,
    quoteId: PropTypes.string.isRequired,
    addVehicleVM: PropTypes.func,
    createVehicle: PropTypes.func,
    removeVehicle: PropTypes.func,
    showErrors: PropTypes.bool
};
VehicleComponent.defaultProps = {
    data: {},
    accountHolder: {},
    garrageAddress: {},
    vehicles: {},
    vinNumber: '',
    lease: false,
    isVehiclePrimarilyKeptAtAddress: false,
    labelPosition: 'left',
    path: undefined,
    readOnlyFields: [],
    showOptional: true,
    addVehicleVM: undefined,
    createVehicle: undefined,
    removeVehicle: undefined,
    showErrors: false
};
export default VehicleComponent;
